import type { ReactNode } from 'react';
import track from 'react-tracking';
import { Modal } from '@simplywallst/ui-core';

export interface HelpModalProps {
  title?: string;
  isVisible: boolean;
  onClose: () => void;
  children: ReactNode;
}

const HelpModal = ({ title, onClose, isVisible, children }: HelpModalProps) => {
  return isVisible ? (
    <Modal
      title={title}
      onSecondaryClick={onClose}
      onPrimaryClick={onClose}
      primaryLabel="Close"
    >
      {children}
    </Modal>
  ) : null;
};

export default track(({ title }) => ({
  type: 'track',
  chart: title,
  subject: 'HelpModal',
}))(HelpModal);
